import { useState } from "react";
import { useQuery } from "react-query";
import { useSnackbar } from "./useSnackbar";
import { useAuth } from "./useAuth";
import MainUseCase from "../usecases/MainUseCase";
import MainApi from "../api/MainApi";

export function useImage(pathLogo: string | null | undefined, pathSignature: string | null | undefined) {
  const { showSnackbar } = useSnackbar();
  const { setExpired } = useAuth();
  const [logo, setLogo] = useState<any>();
  const [signature, setSignature] = useState<any>();
  // const [invoiceLoading, setInvoiceLoading] = useState<boolean>(true);

  const repository = new MainUseCase(new MainApi());

  // Fetch invoice details when token is available
  const { isLoading: isLogoLoading } = useQuery({
    enabled: !!pathLogo, // Only fetch when token exists
    refetchOnWindowFocus: false,
    retry: false,
    queryKey: ["invoice", pathLogo],
    queryFn: async () => repository.getImagePath(pathLogo as string),
    onSuccess: (results: any) => {
      setLogo(results);
    },
    onError: (error: any) => {
      if (
        error.response === undefined ||
        error.response.data === "Read timed out" ||
        error.response.status === 500
      ) {
        showSnackbar("Error - Terjadi Kendala");
      } else if (
        error.response.data !== undefined &&
        error.response.status !== 401
      ) {
        showSnackbar(error.response.data.responseMessage);
      } else if (error.response.status === 401) {
        setExpired(true);
      } else {
        showSnackbar("Error - Terjadi Kendala");
      }
    },
  });
  // Fetch invoice details when token is available
  const { isLoading: isSignatureLoading } = useQuery({
    enabled: !!pathSignature, // Only fetch when token exists
    refetchOnWindowFocus: false,
    retry: false,
    queryKey: ["invoice", pathSignature],
    queryFn: async () => repository.getImagePath(pathSignature as string),
    onSuccess: (results: any) => {
      // console.log("results signature", results);
      setSignature(results);
    },
    onError: (error: any) => {
      if (
        error.response === undefined ||
        error.response.data === "Read timed out" ||
        error.response.status === 500
      ) {
        showSnackbar("Error - Terjadi Kendala");
      } else if (
        error.response.data !== undefined &&
        error.response.status !== 401
      ) {
        showSnackbar(error.response.data.responseMessage);
      } else if (error.response.status === 401) {
        setExpired(true);
      } else {
        showSnackbar("Error - Terjadi Kendala");
      }
    },
  });

  return { logo, signature, isLogoLoading, isSignatureLoading };
}
